// components/LoadingSpinner.tsx - Reusable loading spinner component
import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  message,
  className = ''
}) => {
  const sizeClasses = {
    small: 'h-6 w-6',
    medium: 'h-10 w-10',
    large: 'h-16 w-16'
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className={`animate-spin rounded-full border-b-2 border-blue ${sizeClasses[size]}`}></div>
      {message && (
        <p className="mt-4 text-grey text-sm">{message}</p>
      )}
    </div>
  );
};

export default React.memo(LoadingSpinner);